<script>
  // The label+control wrapper for a filter. The label row ALWAYS reserves height
  // (even with no label) so that every filter item in the items-end FilterBar row is
  // the same total height — tops and controls line up, no ragged gaps between a
  // labeled select and a label-less control.
  //   <FilterField label="Category">{control}</FilterField>
  let { label = null, for: forId = undefined, children } = $props()
</script>

<div class="flex flex-col gap-1">
  {#if label}
    <label class="text-xs font-medium text-base-content/60 h-4 leading-4 whitespace-nowrap" for={forId}>{label}</label>
  {:else}
    <span class="h-4" aria-hidden="true"></span>
  {/if}
  {@render children()}
</div>
